import { createMultiStyleConfigHelpers as r } from "@chakra-ui/react";
import { iconSizes as e } from "../../foundations/icons.mjs";
const { defineMultiStyleConfig: l, definePartsStyle: a } = r([
  "container",
  "statusIcon",
  "body",
  "title",
  "description",
  "actionSlot",
  "close"
]), s = a((t) => {
  const { colorScheme: o } = t;
  return {
    container: {
      border: "1px solid black",
      borderColor: `${o}.500`,
      borderRadius: "lg",
      flexDir: "row",
      paddingX: { base: 4, md: 6 },
      paddingY: { base: 2, md: 3 },
      gap: { base: 2, md: 3 },
      backgroundColor: "white"
    },
    statusIcon: {
      color: `${o}.500`,
      marginTop: { base: 0.5, md: 0 },
      w: { base: e.xl, md: e["2xl"] },
      h: { base: e.xl, md: e["2xl"] }
    },
    body: {
      flexDir: { base: "column", md: "row" },
      flex: 1,
      alignItems: { base: "flex-start", md: "center" },
      gap: { base: 2, md: 3 }
    },
    title: {
      color: `${o}.600`,
      textStyle: "bodyBold"
    },
    description: {
      textStyle: "body"
    },
    close: {
      paddingLeft: { base: 2, md: 3 },
      borderLeft: "1px solid var(--sgi-colors-gray-200)"
    }
  };
}), n = l({
  baseStyle: s,
  variants: {},
  defaultProps: {}
});
export {
  n as default
};
